/**
 * alfavita-quiz2b.js · v2 (event-name step tracking)
 * 20-step hair loss diagnostic quiz for AlfaVita Shopify store.
 * Collects answers Q1-Q18 + email → logs to Notion via Cloudflare Worker at /quiz2b.
 * Per-step tracking: fbq('trackCustom', 'Quiz2bStep' + N) — event name encodes step
 * because Meta strips custom params for sensitive-vertical (hair loss) pixels.
 */

(function () {
  'use strict';

  var answers = {
    q1: '', q2: '', q3: '', q4: '', q5: '', q6: [],
    q8: '', q9: '', q10: '', q12: '', q13: '',
    q16: '', q17: '', q18: '', email: ''
  };

  var totalSteps = 20;
  var wrap;

  // ── Per-step funnel tracking ──────────────────────────────────────────────
  // Fires Meta Pixel custom event + GA4 + Clarity tag on every step transition.
  // sessionId lets you correlate steps within Meta's custom-conversion reports
  // and inside Clarity recordings filtered by `quiz2b_step`.
  var sessionId = 'q' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
  var lastStep  = 0;

  function trackStep(n) {
    if (n === lastStep) return; // dedupe accidental re-fires
    lastStep = n;
    try {
      // fbq: encode step in event name (Meta strips custom params for hair-loss vertical)
      if (window.fbq) {
        window.fbq('trackCustom', 'Quiz2bStep' + n);
      }
      if (window.gtag) {
        window.gtag('event', 'quiz2b_step_view', { step: n, session_id: sessionId });
      }
      if (window.clarity) {
        window.clarity('set', 'quiz2b_step', String(n));      // filterable tag on the session
        window.clarity('event', 'Quiz2bStep' + n);             // Smart Event → usable as a funnel step
      }
    } catch (e) { /* silent — never break the quiz on a tracking error */ }
  }

  function goToStep(n) {
    document.querySelectorAll('.avq2b-step').forEach(function (s) {
      s.classList.remove('avq2b-active');
    });
    var target = document.getElementById('avq2b-' + n);
    if (target) {
      target.classList.add('avq2b-active');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // Update dots — all dots up to current step turn blue
    document.querySelectorAll('.avq2b-dot').forEach(function (dot, i) {
      dot.classList.toggle('avq2b-dot-active', i < n);
    });

    if (n === 18) runPctCounters();

    trackStep(n);
  }

  // ── Slide 19: animates SVG circle strokes + percentage text counters
  var CIRCUMFERENCE = 289.03; // 2 * π * r46
  function runPctCounters() {
    var counters = [
      { pctId: 'avq2b-pct-metas',      circleId: 'avq2b-circle-metas',      target: 92, delay: 200  },
      { pctId: 'avq2b-pct-ajuste',     circleId: 'avq2b-circle-ajuste',     target: 88, delay: 700  },
      { pctId: 'avq2b-pct-esenciales', circleId: 'avq2b-circle-esenciales', target: 95, delay: 1200 }
    ];
    counters.forEach(function (c) {
      setTimeout(function () {
        var pctEl    = document.getElementById(c.pctId);
        var circleEl = document.getElementById(c.circleId);
        if (!pctEl) return;
        var startTime = null;
        var duration  = 1200;
        function tick(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var eased    = 1 - Math.pow(1 - progress, 3);
          var pct      = eased * c.target;
          pctEl.textContent = Math.floor(pct) + '%';
          if (circleEl) circleEl.style.strokeDashoffset = (CIRCUMFERENCE * (1 - pct / 100)).toFixed(2);
          if (progress < 1) {
            requestAnimationFrame(tick);
          } else {
            pctEl.textContent = c.target + '%';
            if (circleEl) circleEl.style.strokeDashoffset = (CIRCUMFERENCE * (1 - c.target / 100)).toFixed(2);
          }
        }
        requestAnimationFrame(tick);
      }, c.delay);
    });
  }

  // ── Single-choice: image cards, text cards, yes/no buttons ───────────────
  function handleOptionClick(e) {
    var el     = e.currentTarget;
    var q      = el.dataset.q;
    var answer = el.dataset.answer;
    var step   = parseInt(el.dataset.step, 10);
    if (q) answers['q' + q] = answer;
    el.style.borderColor = '#005bd3';
    setTimeout(function () { goToStep(step + 1); }, 160);
  }

  // ── Continuar on interstitial steps ──────────────────────────────────────
  function handleContinueClick(e) {
    var step = parseInt(e.currentTarget.dataset.step, 10);
    goToStep(step + 1);
  }

  // ── Multi-select (Q6) ─────────────────────────────────────────────────────
  function handleMultiContinue() {
    var selected = [];
    document.querySelectorAll('.avq2b-checkbox:checked').forEach(function (cb) {
      selected.push(cb.value);
    });
    answers.q6 = selected;
    goToStep(6);
  }

  // ── Step 18 loader: "Enviar" goes to email capture (step 19) ─────────────
  function handleGoToEmail() {
    goToStep(19);
  }

  // ── Step 20: email validation + final submit ──────────────────────────────
  function handleEmailSubmit(e) {
    e.preventDefault();
    var emailInput = document.getElementById('avq2b-email-input');
    var emailError = document.getElementById('avq2b-email-error');
    var submitBtn  = document.getElementById('avq2b-email-submit');
    var email      = emailInput ? emailInput.value.trim() : '';

    // Email is required
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (emailError) emailError.style.display = 'block';
      return;
    }
    if (emailError) emailError.style.display = 'none';
    if (submitBtn)  submitBtn.disabled = true;

    answers.email = email;

    var workerUrl   = (wrap.dataset.worker   || '').trim();
    var redirectUrl = (wrap.dataset.redirect || 'https://alfavitamx.com/pages/alfavita2').trim();

    function doRedirect() { window.location.href = redirectUrl; }

    if (workerUrl) {
      fetch(workerUrl + '/quiz2b', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          source: window.location.href,
          email: answers.email,
          q1: answers.q1, q2: answers.q2, q3: answers.q3,
          q4: answers.q4, q5: answers.q5, q6: answers.q6.join(', '),
          q8: answers.q8, q9: answers.q9, q10: answers.q10,
          q12: answers.q12, q13: answers.q13, q16: answers.q16,
          q17: answers.q17, q18: answers.q18
        })
      }).then(doRedirect).catch(doRedirect);
      setTimeout(doRedirect, 3000);
    } else {
      doRedirect();
    }
  }

  function init() {
    wrap = document.querySelector('.avq2b-wrap');
    if (!wrap) return;

    // Skip link
    var skipBtn = document.getElementById('avq2b-skip');
    if (skipBtn) {
      skipBtn.addEventListener('click', function () {
        window.location.href = wrap.dataset.redirect || 'https://alfavitamx.com/pages/alfavita2';
      });
    }

    // Single-choice cards / yes-no buttons
    document.querySelectorAll('.avq2b-card-big[data-q], .avq2b-card[data-q], .avq2b-text-card[data-q], .avq2b-yesno-btn[data-q]').forEach(function (el) {
      el.addEventListener('click', handleOptionClick);
    });

    // Continuar buttons
    document.querySelectorAll('.avq2b-continue-btn').forEach(function (btn) {
      btn.addEventListener('click', handleContinueClick);
    });

    // Multi-select continue (Q6)
    var multiContinue = document.getElementById('avq2b-multi-continue');
    if (multiContinue) multiContinue.addEventListener('click', handleMultiContinue);

    // "Todas las anteriores" toggle
    var allCheck = document.querySelector('.avq2b-check-all');
    if (allCheck) {
      allCheck.addEventListener('change', function () {
        document.querySelectorAll('.avq2b-checkbox:not(.avq2b-check-all)').forEach(function (cb) {
          cb.checked = allCheck.checked;
        });
      });
    }

    // Step 19: "Enviar" → go to email step
    var finalBtn = document.getElementById('avq2b-final-btn');
    if (finalBtn) finalBtn.addEventListener('click', handleGoToEmail);

    // Step 20: email form submit
    var emailForm = document.getElementById('avq2b-email-form');
    if (emailForm) emailForm.addEventListener('submit', handleEmailSubmit);

    // Fire the step-1 view (page lands on step 1 without an explicit goToStep call)
    trackStep(1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
